<script>
import Jobs from "@/components/jobs/Jobs.vue";
import SearchJob from "@/components/jobs/SearchJob.vue";

export default {
  data() {
    return {
      opportunity: null,
    };
  },
  head() {
    return this.$head({
      title: "Vagas | ",
    });
  },

  components: {
    Jobs,
    SearchJob,
  },
};
</script>

<template>
  <div class="collection">
    <div class="container">
      <h1>sobre a dudalina</h1>
      <p>
      Com excelência na produção de camisas desde 1957, a Dudalina cresceu ao longo das últimas décadas e hoje oferece uma ampla variedade de produtos para homens e mulheres, com destaque para as linhas business, sucesso absoluto.
Nosso foco sempre foi oferecer um guarda-roupa elegante e apropriado para o dia a dia do mercado de trabalho. Além da camisaria – que consagrou a marca com modelos criados com as melhores matérias-primas, acabamentos impecáveis e detalhes de cristais Swarovski –, jeans e peças casuais compõem as coleções, pensadas para todos os momentos da vida, incluindo o lazer. Elegante e cosmopolita, a Dudalina é feita para pessoas que decidem com peças criadas por uma equipe incansável na busca por qualidade, sem perder a sua história.
      </p>
    </div>
  </div>
</template>


<style lang="scss" scoped>
.collection {
    margin-top: 4rem;
}
h1 {
    font-size: 1.9rem;
    text-transform: uppercase;
    font-weight: 500;
    color: #000;
}
p {
    font-size: 1.2rem;
    color: #000;
    margin-top: 1rem;
     border-bottom: 2px solid theme-color(primary);
     padding-bottom: 2rem;
     margin-bottom: 1.5rem;
}
</style>